export default {
	"reportGeneration": {
		"reportType": "report type"
	},
	"reportList": {
		"createReport": "Create a report",
		"loading": "generating",
		"rangeDate": "date range"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/reportdownload/reportdownload.js